/**
 * Reset pool — the link under a group's burned rows and its confirm: it
 * forgives every burn at once, so it asks first.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useState } from 'react';

import { ConfirmDialog } from '@/components/ui';

export const ResetPoolControl: FC<{
  groupName: string;
  containerName: string;
  burned: number;
  onReset: () => void;
  resetting?: boolean;
}> = ({ groupName, containerName, burned, onReset, resetting = false }) => {
  const [confirm, setConfirm] = useState(false);
  return (
    <div className="pl-[52px] text-[11px]">
      <button
        type="button"
        onClick={() => setConfirm(true)}
        className="font-medium text-primary hover:underline"
      >
        Reset pool
      </button>
      <span className="text-muted-foreground">
        {' '}— forgive the burned lists, start the order over
      </span>
      <ConfirmDialog
        open={confirm}
        title={`Reset the pool of ${groupName}?`}
        description={`${burned} burned list${burned === 1 ? '' : 's'} of ${containerName} will be forgiven and the next generate starts from the top of the order. Nothing is deleted on SMSWiser.`}
        confirmLabel="Reset pool"
        busy={resetting}
        onConfirm={() => {
          onReset();
          setConfirm(false);
        }}
        onCancel={() => setConfirm(false)}
      />
    </div>
  );
};
